import { Accordion } from '../../../../../components/general/accordion';
import InfoIcon from '@mui/icons-material/Info';
import { TitleV1 } from '../../../../../components/titleV1';
import LoadingButtonGeneral from '../../../../../components/general/buttons/loadingButtonGeneral';
import SearchIcon from '@mui/icons-material/Search';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SWITCH } from '../../../../../../routes/paths';
import { SwitchForm } from '../../../switch/form';
import { AccountRegisterSwitchFormProps } from './props';

export const AccountRegisterSwitchForm = ({
    isOpen,
}: AccountRegisterSwitchFormProps) => {
    const navigate = useNavigate();

    return (
        <Accordion
            title="REGISTRO CONMUTADOR"
            icon={<InfoIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={isOpen}
            mt={0}
            padding={0}
        >
            <TitleV1 title="CONMUTADOR">
                <LoadingButtonGeneral
                    title="Buscar"
                    variant="outlined"
                    startIcon={<SearchIcon />}
                    onClick={() => navigate(SWITCH)}
                />
            </TitleV1>
            <Grid px="16px">
                <SwitchForm />
            </Grid>
        </Accordion>
    );
};
